import { render, staticRenderFns } from "./Destribute.vue?vue&type=template&id=483a7fec&scoped=true"
import script from "./Destribute.vue?vue&type=script&lang=js"
export * from "./Destribute.vue?vue&type=script&lang=js"
import style0 from "./Destribute.vue?vue&type=style&index=0&id=483a7fec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a7fec",
  null
  
)

export default component.exports